import { css } from '@emotion/react';
import { type FC } from 'react';
import type { BoundaryGroup } from '~/boundary/boundary.types';
import { BoundaryLabelSettingsComponent } from '~/boundary/settings/boundaryLabels/boundaryLabelSettings.component';
import {
  PREVIEW_DIMENSION, SIDES_PADDING,
} from '~/boundary/settings/constants';
import { type BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { BoundarySettingsGroupNameComponent } from '../groupName/boundarySettingsGroupName.component';
import { BoundarySettingsBoundaryPreviewComponent } from './boundarySettingsBoundaryPreview';
import { CommonSettingsContainer } from './commonSettingsContainer';

const boundaryGroupSettingsContainerStyle = css({
  width: '100%',
  paddingTop: 20,
  paddingBottom: 20,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  flexShrink: 0,
  flexGrow: 1,

  '&, & *': {
    boxSizing: 'border-box',
  },
});

const previewAndCheckboxesContainerStyles = css({
  alignItems: 'flex-start',
  display: 'flex',
  gap: 20,
  paddingInline: SIDES_PADDING,
});

export const labelPreviewContainerStyle = css({
  borderRadius: 4,
  flex: '1',
});

type BoundarySettingsGroupProps = Readonly<{
  boundaryGroup: BoundaryGroup;
  boundaryTerritoryGroup: BoundaryTerritoryGroup;
  onBoundaryGroupNameChange?: (newName: string) => void;
  onBoundaryTerritoryGroupChange: (territoryGroup: BoundaryTerritoryGroup) => void;
  setIsFormValid: (isFormValid: boolean) => void;
  setIsLoading: (isFormValid: boolean) => void;
}>;

export const BoundarySettingsComponent: FC<BoundarySettingsGroupProps> = ({
  setIsFormValid,
  setIsLoading,
  boundaryTerritoryGroup,
  boundaryGroup,
  onBoundaryGroupNameChange,
  onBoundaryTerritoryGroupChange,
}) => {
  return (
    <div css={boundaryGroupSettingsContainerStyle}>
      {boundaryGroup.name && (
        <BoundarySettingsGroupNameComponent
          groupName={boundaryGroup.name}
          onGroupNameChange={onBoundaryGroupNameChange}
        />
      )}

      <div css={previewAndCheckboxesContainerStyles}>
        <BoundarySettingsBoundaryPreviewComponent
          css={labelPreviewContainerStyle}
          squareSize={PREVIEW_DIMENSION}
          boundaryTerritoryGroup={boundaryTerritoryGroup}
        />
        <CommonSettingsContainer
          boundaryTerritoryGroup={boundaryTerritoryGroup}
          onBoundaryTerritoryGroupChange={onBoundaryTerritoryGroupChange}
        />
      </div>
      <BoundaryLabelSettingsComponent
        boundaryTerritoryGroup={boundaryTerritoryGroup}
        onBoundaryTerritoryGroupChange={onBoundaryTerritoryGroupChange}
        setIsFormValid={setIsFormValid}
        setIsLoading={setIsLoading}
        boundaryGroup={boundaryGroup}
      />
    </div>
  );
};
